import { AxiosError } from 'axios';

interface CustomAxiosError extends AxiosError {
  statusCode: number | undefined;
  message: any | undefined;
}

const errorStatusCodeConformer = (error: AxiosError) => {
  // Move status code to root - various sagas use this to determine proper error route
  // TODO - More abstracted way for error handling that is decoupled from HTTP client?
  (error as CustomAxiosError).statusCode = error.response ? error.response.status : undefined;
  // @ts-ignore
  (error as CustomAxiosError).message = error?.response?.data?.message ?? undefined;

  throw error;
};

export default errorStatusCodeConformer;
